module.exports = __webpack_public_path__ + "img/pm.9d0be1d4.svg";